module.exports = __webpack_public_path__ + "static/media/vouch2.3465b1a3.png";